/**
 * Collection names and order/payment status constants.
 *
 * These live apart from `firebase-config.js` so that server-side code (the
 * Vercel API routes) can import them WITHOUT pulling in the browser Firebase
 * SDK and initialising a client app inside a serverless function.
 * `firebase-config.js` re-exports everything here, so existing imports are
 * unchanged.
 */

export const collections = {
  ORDERS: "orders",
  PRODUCTS: "products",
  USERS: "users",
  PAYMENT: "payments",
  TYPES: "types",
  CART: "cart",
  // Successful CCAvenue notifications whose order could not be matched land
  // here so they can be reconciled by hand instead of being lost.
  RECONCILIATION: "payment_reconciliation",
};

export const roles = {
  ADMIN: "ADMIN",
  CUSTOMER: "CUSTOMER",
};

export const cart_status = {
  PAYMENTPROCESS: "PAYMENTING",
  ORDERED: "ORDERED",
  PROCESS: "PROCESS",
  DELIVERED: "DELIVERED",
};

export const payment_status = {
  SUCCESS: "Success",
  INITIATED: "Initiated",
  ONPROCESS: "Process",
  ABORTED: "ABORTED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  INVALID: "INVALID",
  REVERSED: "REVERSED",
};

export const carting = {
  ADDED: "INCART",
};
